import { useEffect, useState } from 'react'

const BOX_SCRIPT_URL = "https://cdn.folloze.com/static-assets/platform/preview/preview.js?version=2.81.0.3"
const BOX_CSS_URL = "https://cdn.folloze.com/static-assets/platform/preview/preview.css?version=2.81.0.3"

const useBoxPreview = () => {
  const previewLibraryLoaded = () => !!(global.Box && global.Box.Preview)
  const getPreviewScriptElement = () => document.querySelector(`script[src="${BOX_SCRIPT_URL}"]`)
  const getPreviewCSSElement = () => document.querySelector(`link[href="${BOX_CSS_URL}"]`)
  const [loaded, setLoaded] = useState(previewLibraryLoaded())

  const loadBoxPreviewScript = () => {
    const script = document.createElement('script')
    script.src = BOX_SCRIPT_URL
    script.onload = () => setLoaded(true)
    document.head.appendChild(script)
  }

  const loadBoxPreviewCSS = () => {
    const style = document.createElement("link")
    style.setAttribute("rel", "stylesheet")
    style.setAttribute("type", "text/css")
    style.setAttribute("href", BOX_CSS_URL)
    document.head.appendChild(style)
  }

  useEffect(() => {
    if (!getPreviewScriptElement()) {
      loadBoxPreviewScript()
    }
    if (!getPreviewCSSElement()) {
      loadBoxPreviewCSS()
    }
  }, [])

  return [loaded, setLoaded]
}

export default useBoxPreview